export default "__VITE_ASSET__BEaSixqv__"